import { render, staticRenderFns } from "./propertyDetails.vue?vue&type=template&id=25c1ba20&scoped=true"
import script from "./propertyDetails.vue?vue&type=script&lang=js"
export * from "./propertyDetails.vue?vue&type=script&lang=js"
import style0 from "./propertyDetails.vue?vue&type=style&index=0&id=25c1ba20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1ba20",
  null
  
)

export default component.exports